module.exports = __webpack_public_path__ + "static/media/nissan-icon-noneOption.fb7cb6f4.svg";